import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFormulate from '@braid/vue-formulate'
import vuetify from './plugins/vuetify';
import fb from 'firebase';

Vue.use(VueFormulate);

Vue.config.productionTip = false

if (location.hostname === 'bookaas.com') location.href = location.href.replace('bookaas.com', 'chat-book.by');

new Vue({
  router,
  vuetify,
  render: h => h(App),
  created(){
    var firebaseConfig = {
      apiKey: "AIzaSyA9lfMmh2BtKq67AIVrEDF8eSe7d0Jm6TM",
      authDomain: "bookaas-c3bc6.firebaseapp.com",
      databaseURL: "https://bookaas-c3bc6.firebaseio.com",
      projectId: "bookaas-c3bc6",
      storageBucket: "bookaas-c3bc6.appspot.com",
      messagingSenderId: "444485376891",
      appId: "1:444485376891:web:fe414e642f783b69e0fbde"
    };
    // Initialize Firebase
    fb.initializeApp(firebaseConfig);
    fb.auth().signInWithEmailAndPassword('bookaas232@gmail.com', '1234567').catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log('error');
      console.log(errorCode);
      console.log(errorMessage);
    }).then(() => {
      console.log('firebase connected');
    });

  }
}).$mount('#app')
